import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import api from '../services/api'

const BooksTalkSection = () => {
  const navigate = useNavigate()
  const [items, setItems] = useState([])
  const [categories, setCategories] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    try {
      const res = await api.get('/books-talk')
      if (res.code === 0) {
        setItems(res.data)
        // 提取所有唯一的分类
        const uniqueCategories = []
        const seenIds = new Set()
        res.data.forEach(item => {
          if (item.category && !seenIds.has(item.category.id)) {
            seenIds.add(item.category.id)
            uniqueCategories.push(item.category)
          }
        })
        setCategories(uniqueCategories)
      }
    } catch (error) {
      console.error('加载失败:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleItemClick = (id) => {
    navigate(`/books-talk/${id}`)
  }

  const getItemsByCategory = (categoryId) => {
    return items.filter(item => item.category_id === categoryId)
  }

  if (loading) {
    return (
      <div className="books-talk-loading">加载中...</div>
    )
  }

  return (
    <section className="section">
      <div className="section-header">
        <span className="section-title">萝卜讲书</span>
        <span className="section-count">// 精品讲书</span>
      </div>
      
      {categories.map(category => {
        const categoryItems = getItemsByCategory(category.id)
        if (categoryItems.length === 0) return null
        
        return (
          <div key={category.id}>
            <div className="category-label">{category.name}</div>
            <div className="card-grid grid-3">
              {categoryItems.map((item, index) => (
                <div 
                  key={item.id} 
                  className="book-talk-card card-anim"
                  style={{ animationDelay: `${index * 0.05}s` }}
                  onClick={() => handleItemClick(item.id)}
                >
                  <div className="book-talk-card-cover">
                    {item.cover_image ? (
                      <img src={item.cover_image} alt={item.title} />
                    ) : (
                      <div className="book-talk-card-cover-placeholder">📚</div>
                    )}
                  </div>
                  <div className="book-talk-card-info">
                    <div className="book-talk-card-title">{item.title}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )
      })}
    </section>
  )
}

export default BooksTalkSection
